function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.4219 14.3542H70.7031V47.5574H82.4219V14.3542Z",
  fill: "#eb392e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M129.297 14.3542H117.578V47.5574H129.297V14.3542Z",
  fill: "#eb392e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M105.859 0.0375977H94.1406V35.1938H105.859V0.0375977Z",
  fill: "#eb392e"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M159.816 113.243C145.227 98.6546 126.248 90.055 105.859 88.669V74.7944H94.1405V88.669C73.7514 90.055 54.7721 98.6546 40.1834 113.243C25.5952 127.832 16.9956 146.811 15.6096 167.2H184.39C183.004 146.811 174.405 127.831 159.816 113.243Z",
  fill: "#eb392e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M200 178.921H0V199.962H200V178.921Z",
  fill: "#eb392e"
});

var SvgMeal = function SvgMeal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meal.85700eed.svg";
export { ForwardRef as ReactComponent };